import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

function getDeviceScale() {
  return window.devicePixelRatio || 1
}

function resolveScale({ page, scale, rotation, fitMode, containerWidth, containerHeight }) {
  const baseViewport = page.getViewport({ scale: 1, rotation })

  if (fitMode === 'fit-width' && containerWidth) {
    return Number(((containerWidth - 24) / baseViewport.width).toFixed(3))
  }

  if (fitMode === 'fit-page' && containerWidth && containerHeight) {
    const widthScale = (containerWidth - 24) / baseViewport.width
    const heightScale = (containerHeight - 24) / baseViewport.height
    return Number(Math.min(widthScale, heightScale).toFixed(3))
  }

  return scale
}

export async function loadDocument(sourceUrl) {
  const loadingTask = pdfjsLib.getDocument({
    url: sourceUrl,
    cMapPacked: true,
  })

  const pdfDoc = await loadingTask.promise

  return {
    loadingTask,
    pdfDoc,
  }
}

export async function renderPage({
  pdfDoc,
  pageNumber,
  canvas,
  scale = 1,
  rotation = 0,
  fitMode = 'custom',
  containerWidth = 0,
  containerHeight = 0,
}) {
  const page = await pdfDoc.getPage(pageNumber)
  const resolvedScale = resolveScale({
    page,
    scale,
    rotation,
    fitMode,
    containerWidth,
    containerHeight,
  })
  const viewport = page.getViewport({ scale: resolvedScale, rotation })
  const outputScale = getDeviceScale()
  const transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null
  const context = canvas.getContext('2d')

  canvas.width = Math.floor(viewport.width * outputScale)
  canvas.height = Math.floor(viewport.height * outputScale)
  canvas.style.width = `${Math.floor(viewport.width)}px`
  canvas.style.height = `${Math.floor(viewport.height)}px`

  const renderTask = page.render({
    canvasContext: context,
    viewport,
    transform,
    background: '#ffffff',
  })

  return {
    page,
    renderTask,
    viewport,
    scale: resolvedScale,
  }
}

export function cancelRender(renderTask) {
  if (renderTask && typeof renderTask.cancel === 'function') {
    renderTask.cancel()
  }
}

export async function destroyDocument({ loadingTask, pdfDoc }) {
  if (loadingTask && typeof loadingTask.destroy === 'function') {
    try {
      await loadingTask.destroy()
    } catch (error) {
      void error
    }
  }

  if (pdfDoc && typeof pdfDoc.destroy === 'function') {
    try {
      await pdfDoc.destroy()
    } catch (error) {
      void error
    }
  }
}
